import Layout2 from '@/layout/Layout2'
import LayoutBlank from '@/layout/LayoutBlank'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/qrcode',
    component: LayoutBlank,
    children: [{
        path: '',
        name: "qrcode",
        component: () => import('@/merchanAdmin/qrcode/qrcode'),
        meta: {
            zhtitle: zh.m.router.common.QR_CODE,
            jatitle: ja.m.router.common.QR_CODE,
            pername: "shop_setting"
        },
    }]
}]
